import styled, { css } from "styled-components";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 0.2rem;
	width: fit-content;
`;

export const ProgressBar = styled.div`
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	transform: translateY(-50%);
	display: flex;
	flex: 1;
	height: 2px;
	background-color: ${({ theme }) => theme.pantone2726C};
	z-index: 1;
`;
const completedStepsStyles = css`
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	background-color: ${({ theme }) => theme.pantone2726C};
	color: ${({ theme }) => theme.white};
	filter: grayscale(0);
`;
const loadingStepsStyles = css`
	cursor: progress;
`;
const activedStepsStyles = css`
	background-color: ${({ theme }) => theme.white};
	color: ${({ theme }) => theme.pantone2726C};
	filter: grayscale(0);
	&:hover {
		filter: brightness(0.9);
	}
`;

interface IStepProps {
	$isActive: boolean;
	$isCompleted: boolean;
	$isLoading: boolean;
}
export const Step = styled.div<IStepProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	border-radius: 50%;
	background-color: ${({ theme }) => theme.pantone642C};
	color: ${({ theme }) => theme.pantone2726C};
	filter: grayscale(0.6);
	font-size: 0.8rem;
	cursor: pointer;
	user-select: none;
	z-index: 2;
	transition: filter 0.2s;

	&:hover {
		filter: brightness(1);
	}

	${({ $isActive }) => $isActive && activedStepsStyles};
	${({ $isCompleted }) => $isCompleted && completedStepsStyles};
	${({ $isLoading }) => $isLoading && loadingStepsStyles};
`;
